import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import '../nurturer-auth/styles/auth.css';
import AuthShell from '../nurturer-auth/components/AuthShell';
import AuthPageBrand from '../nurturer-auth/components/AuthPageBrand';
import { registerAside } from '../nurturer-auth/components/authAsides';
import RegisterForm from '../nurturer-auth/forms/RegisterForm';

function Register() {
  const { isAuth } = useSelector((state) => state.login);

  if (isAuth) {
    return <Redirect to="/apps/dashboard" />;
  }

  return (
    <AuthShell aside={registerAside}>
      <AuthPageBrand />
      <div className="auth-head">
        <h1>
          Create your <em>account</em>
        </h1>
        <p>Start nurturing the leads you didn&apos;t close — in minutes.</p>
      </div>
      <RegisterForm />
      <div className="alt">
        Already have an account?{' '}
        <Link className="link" to="/login">
          Log in
        </Link>
      </div>
    </AuthShell>
  );
}

export default Register;
